<template>
  <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
    <div class="box" v-if="flag" id="box" @click="flag = false">
      <div class="play">
        <div v-if="showList"></div>
        <img :src="url" v-else-if="picflag" />
        <div v-else @click.stop="" style="width: 100%">
          <video-player
            style="width: 100%"
            class="video-player vjs-custom-skin video"
            ref="videoPlayer"
            :playsinline="true"
            :options="playerOptions"
          >
          </video-player>
        </div>
      </div>
      <!-- <div class="btnList" v-if="showBtn">
        <el-button type="primary" @click.stop="toXq(1)">科技幻影</el-button>
        <el-button type="primary" @click.stop="toXq(2)">高贵典雅</el-button>
        <el-button type="primary" @click.stop="toXq(3)">梦幻气泡</el-button>
      </div> -->
    </div>
  </transition>
</template>

<script>
import Bus from "../../common/js/bus";
export default {
  data() {
    return {
      flag: false,
      picflag: "",
      url: "",
      showBtn: false,
      playerOptions: {
        playbackRates: [0.5, 1.0, 1.5, 2.0], //倍速控制
        autoplay: true, //是否自动播放
        muted: false, //是否静音播放
        loop: false, //是否循环播放
        preload: "auto",
        language: "zh-CN", //语言，还要引入对应的文件
        aspectRatio: "16:9", //比例
        fluid: true,
        sources: [
          {
            type: "",
            src: "", //url地址
          },
        ],
        poster: "", //你的封面地址
        notSupportedMessage: "此视频暂无法播放，请稍后再试",
        controlBar: {
          timeDivider: true,
          durationDisplay: true, //剩余时间是否显示
          remainingTimeDisplay: false, //剩余时间是否显示，有一个即可
          fullscreenToggle: true, //全屏按钮
        },
      },
    };
  },

  created() {
    this.Bus.$on("showBox", (e) => {
      // if (e.id == 15) {
      //   this.to();
      //   return;
      // }
      if (e.id > 96 && e.id < 109) {
        this.showBtn = true;
      } else {
        this.showBtn = false;
      }
      console.log(e);
      var url = e.publish_url;
      this.url = url;
      var pos = url.indexOf("?");
      let ext = url.substr(pos - 3, 3);
      ext = ext.toLowerCase();
      if (ext == "jpg" || ext == "bmp" || ext == "png" || ext == "tga") {
        this.picflag = true;
      } else if (ext == "mp4") {
        this.picflag = false;
        this.playerOptions.sources[0].src = url;
      }
      this.flag = true;
    });
  },

  methods: {
    toXq(e) {
      console.log(e);
      if (this.$chat.role.auth < 2) {
        this.$confirm("您还未认证, 是否认证?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "success",
        })
          .then(() => {
            Bus.$emit("renzheng");
            this.flag = false;
          })
          .catch(() => {
            that.$message({
              type: "info",
              message: "已取消",
            });
          });

        // this.$message.error("您还未认证，无法前往相亲场景");
        return;
      }
      localStorage.setItem("dateType", e);
      // window.location.href = "https://o2vr.net/upload/O2VRWEBGL/xiangqin";
      window.location.href = "https://ost-digital-isp.innoecos.cn/Thcactivity/";
    },
    to() {
      if (this.$chat.role.auth < 2) {
        return;
      }
      this.$confirm("此操作将跳转至i站指挥中心, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "success",
      })
        .then(() => {
          window.open(
            "https://datav.aliyuncs.com/share/8d84c87ce7f38091f10d271e9f697df3"
          );
          that.$message({
            type: "success",
            message: "跳转成功!",
          });
        })
        .catch(() => {
          that.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.btnList {
  margin-top: 30px;
  position: absolute;
  width: 100%;
  display: flex;
  justify-content: center;
  button {
    margin: 0 20px;
    cursor: pointer;
  }
}
.box {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  background: rgba($color: #000000, $alpha: 0.5);
  z-index: 10000;
}
.play {
  position: absolute;
  width: 70%;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  margin: auto;
  display: flex;
  justify-content: center;
  img {
    height: 80%;
  }
}
</style>
